// shared/context/tutorial-context.js
import { createContext } from "react";

export const TutorialContext = createContext({
  showTutorial: () => {},
  closeTutorial: () => {},
  isOpen: false,
});
